/*global VeloxWebView*/


/**
 * Extension to search cities in ZIP Codes
 */
var extension = {} ;
extension.name = "disinf-field" ;

//must run after fields
extension.mustRunAfter = ["fields", "country"] ;

var COUNTRY_AVAILABILITY = {
    "CHLORILONG_250" :      { FR: true, DE: true, ES: true, GB: true}, 
    "CHLORILONG" :          { FR: true, DE: true, ES: true, GB: true}, 
    "CHLORILONG_BLOC" :     { FR: true, DE: false,ES: true, GB: true}, 
    "CHLORILONG_5FUNC" :    { FR: true, DE: true, ES: true, GB: true},  
    "CHLORILONG_5F" :       { FR: true, DE: true, ES: true, GB: true},  
    "CHLORYTE_STICKS" :     { FR: true, DE: false, ES: true, GB: true},  
    "CHLORE_5F" :           { FR: true, DE: true, ES: false,GB: true}, 
    "VARITAB" :             { FR: true, DE: true, ES: true, GB: true},  
    "MULTIBLOC" :           { FR: true, DE: true, ES: false,GB: true},  
    "MULTILONG" :           { FR: true, DE: false,ES: true, GB: true},  
    "CHLORILIQ_C" :         { FR: true, DE: true, ES: true, GB: false},  
    "CHLORILIQUE_C" :       { FR: true, DE: true, ES: true, GB: false}, 
    "COMPLETE_EASY" :       { FR: true, DE: true, ES: false,GB: true},  
    "C_AND_E" :             { FR: true, DE: true, ES: false,GB: true}, 
    "AQUABROME" :           { FR: true, DE: true, ES: true, GB: true}, 
    "SOFT_EASY_20" :        { FR: true, DE: true, ES: true, GB: true},  
    "S_AND_E_20" :          { FR: true, DE: true, ES: true, GB: true},  
    "SOFT_EASY_30" :        { FR: true, DE: true, ES: true, GB: true},  
    "S_AND_E_30" :          { FR: true, DE: true, ES: true, GB: true},  
    "SOFT_SWIM_MULTI" :     { FR: true, DE: false, ES: true, GB: true},  
    "SOFTSWIM_MULTI" :      { FR: true, DE: false, ES: true, GB: true}, 
    "BAYROSOFT" :           { FR: false, DE: false, ES: true, GB: true}, 
    "BAYROSOFT_LIGHT" :     { FR: true, DE: true, ES: false, GB: false}, 
    "CHLORIKLAR" :          { FR: true, DE: true, ES: true, GB: true},   
    "CHLORIFIX_MICRO" :     { FR: true, DE: true, ES: true, GB: true},  
    "CHLORIFIX" :           { FR: true, DE: true, ES: true, GB: true},  
    "CHLORYTE" :            { FR: true, DE: true,ES: true, GB: true}, 
    "AQUABROME_REGENERATOR":{ FR: true, DE: true, ES: false,GB: true},  
    "BAYROSHOCK" :          { FR: true, DE: false, ES: false,GB: true}, 
    "BAYROSHOCK_LIGHT" :    { FR: false, DE: true, ES: false,GB: false}, 
    "CL_MICROBILLE" :       { FR: true, DE: true, ES: true, GB: true}, 
    "CL_MICROBILLELONG" :   { FR: true, DE: true, ES: true, GB: true}, 
    "DISINF_PLUS" :         { FR: true, DE: true, ES: false,GB: true}, 
    "BROME_SPATIME" :       { FR: true, DE: true, ES: true, GB: true}, 
    "ACTIVE_OXY_SPATIME" :  { FR: true, DE: true, ES: false,GB: true}, 
    "OXY_SPATIME" :         { FR: true, DE: true, ES: false,GB: true}, 
};

extension.COUNTRY_AVAILABILITY = COUNTRY_AVAILABILITY ;

var PRODUCT_LONG_BY_DISINF = {
    "CHLORINE": [
        "CHLORILONG",  "CHLORILONG_BLOC", "CHLORILONG_5F", "VARITAB",        
        "MULTIBLOC", "MULTILONG", "CHLORILIQUE_C", "C_AND_E", "CHLORE_5F", "CHLORYTE_STICKS"      
    ],
    "BROMINE": ["AQUABROME"],
    "OXYGEN": [
        "S_AND_E_20", "S_AND_E_30", "SOFTSWIM_MULTI", "BAYROSOFT", "BAYROSOFT_LIGHT"
    ]
};

var PRODUCT_SHOCK_BY_DISINF = {
    "CHLORINE": [
        "CHLORIKLAR",  "CHLORIFIX", "CHLORYTE"
    ],
    "BROMINE": ["AQUABROME_REGENERATOR", "CHLORYTE"],
    "OXYGEN": [
        "BAYROSHOCK", "CHLORIKLAR", "CHLORIFIX", "CHLORYTE", "BAYROSHOCK_LIGHT" 
    ]
};

var PRODUCT_LONG_BY_DISINF_SPA = {
    "CHLORINE": [
        "CL_MICROBILLELONG", "CHLORILIQUE_C"     
    ],
    "BROMINE": ["BROME_SPATIME"],
    "OXYGEN": [
        "OXY_SPATIME", "BAYROSOFT_LIGHT"      
    ]
};

var PRODUCT_SHOCK_BY_DISINF_SPA = {
    "CHLORINE": [
        "CL_MICROBILLE",  "DISINF_PLUS"
    ],
    "BROMINE": ["CL_MICROBILLE",  "DISINF_PLUS"],
    "OXYGEN": [
        "ACTIVE_OXY_SPATIME", "CL_MICROBILLE",  "DISINF_PLUS", "BAYROSHOCK_LIGHT" 
    ]
};

function computeOptionsLong(disinf, isPool){
    if(!disinf){ return [] ;}
    if(disinf === "SALT"){ disinf = "CHLORINE" ;}
    var product = PRODUCT_LONG_BY_DISINF ;
    if(!isPool){
        product = PRODUCT_LONG_BY_DISINF_SPA ;
    }
    return product[disinf].filter(function(p){
        //filter by country availability
        return COUNTRY_AVAILABILITY[p][VeloxWebView.country.get()] ;
    }).map(function(p){
        return {
            id: p,
            label: isPool?VeloxWebView.tr("fields.values.pool.p_disinf_long."+p):VeloxWebView.tr("fields.values.spa.s_disinf_long."+p)
        } ;
    });
}

function computeOptionsShock(disinf, isPool){
    if(!disinf){ return [] ;}
    if(disinf === "SALT"){ disinf = "CHLORINE" ;}
    var product = PRODUCT_SHOCK_BY_DISINF ;
    if(!isPool){
        product = PRODUCT_SHOCK_BY_DISINF_SPA ;
    }
    return product[disinf].filter(function(p){
        //filter by country availability
        return COUNTRY_AVAILABILITY[p][VeloxWebView.country.get()] ;
    }).map(function(p){
        return {
            id: p,
            label: isPool?VeloxWebView.tr("fields.values.pool.p_disinf_shock."+p):VeloxWebView.tr("fields.values.spa.s_disinf_shock."+p)
        } ;
    }) ;
}

var VISIBILITY = {
    "CHLORINE": { 
        show: ["diag.d_free_cl", "diag.d_total_cl", "diag.d_stab"],
        required: ["diag.d_free_cl"],
        hide: ["diag.p_disinf_salt_rate", "diag.s_disinf_salt_rate",
            "diag.d_br", "diag.d_salt", "diag.d_salt_disolved", "diag.d_oxygen"
        ],
    },
    "BROMINE": { 
        show: ["diag.d_br"],
        required: ["diag.d_br"],
        hide: [ "diag.p_disinf_salt_rate",  "diag.s_disinf_salt_rate",
            "diag.d_free_cl", "diag.d_total_cl", "diag.d_stab", "diag.d_salt", "diag.d_salt_disolved", "diag.d_oxygen"
        ],
    },
    "OXYGEN": { 
        show: ["diag.d_stab","diag.d_oxygen"],
        required: [],
        hide: ["diag.p_disinf_salt_rate", "diag.s_disinf_salt_rate",
            "diag.d_br", "diag.d_free_cl", "diag.d_total_cl",  "diag.d_salt", "diag.d_salt_disolved", 
        ],
    },
    "SALT": { 
        show: ["diag.p_disinf_salt_rate", "diag.s_disinf_salt_rate",
        "diag.d_stab","diag.d_free_cl", "diag.d_total_cl",  "diag.d_salt", "diag.d_salt_disolved"],
        required: ["diag.d_free_cl"],
        hide: [
            "diag.d_br","diag.d_oxygen" , 
        ],
    },
} ;

var FIELDS_DISINF = [
    {disinf : "pool.p_disinfectant", long : "pool.p_disinf_long", shock: "pool.p_disinf_shock", salt: "pool.p_disinf_salt_rate"},
    {disinf : "spa.s_disinfectant", long : "spa.s_disinf_long", shock: "spa.s_disinf_shock", salt: "spa.s_disinf_salt_rate"},
    {disinf : "diag.p_disinfectant", long : "diag.p_disinf_long", shock: "diag.p_disinf_shock", salt: "diag.p_disinf_salt_rate"},
    {disinf : "diag.s_disinfectant", long : "diag.s_disinf_long", shock: "diag.s_disinf_shock", salt: "diag.s_disinf_salt_rate"}
] ;

extension.init = function(){
    var view = this ;
    view.on("initDone", function(){
        FIELDS_DISINF.forEach(function(f){
            var rootView = view.getRootView() ;
            var disinfEl = rootView.viewRootEl.querySelector('[data-field-def="'+f.disinf+'"]');
            if(disinfEl){
                if(VeloxWebView.country.get() === "ES"){
                    disinfEl.setOptions(disinfEl.getOptions().filter(function(opt){
                        if(opt.id === "OXYGEN"){
                            return false;
                        }
                        return true ;
                    })) ;
                }
                var disinfLongEl = rootView.viewRootEl.querySelector('[data-field-def="'+f.long+'"]');
                var disinfShockEl = rootView.viewRootEl.querySelector('[data-field-def="'+f.shock+'"]');
                var disinfSaltEl = rootView.viewRootEl.querySelector('[data-field-def="'+f.salt+'"]');
                var isPool = disinfEl.getAttribute("data-field-def").indexOf("p_disinfectant") !== -1 ;
                function onChange(){
                    var disinf = disinfEl.getValue() ;
                    if(disinfLongEl){
                        disinfLongEl.setOptions(computeOptionsLong(disinf, isPool)) ;
                    }
                    if(disinfShockEl){
                        disinfShockEl.setOptions(computeOptionsShock(disinf, isPool)) ;
                    }

                    rootView.ensureOpen(function(){
                        if(rootView.productFiltering){
                            rootView.productFiltering() ;
                        }
                    }) ;
    
                    if(disinfLongEl){
                        disinfLongEl.style.display = "none" ;
                    }

                    if(disinfShockEl){
                        disinfShockEl.style.display = "none" ;
                    }
                    
                    Object.keys(VISIBILITY).forEach(function(k){
                        VISIBILITY[k].required.forEach(function(fieldName){
                            var el = rootView.viewRootEl.querySelector('[data-field-def="'+fieldName+'"]');
                            if(el){
                                el.setRequired(false) ;
                            }
                        }) ;
                    }) ;

                    if(!disinf){
                        //hide all
                        if(disinfSaltEl){
                            disinfSaltEl.style.display = "none" ;
                        }
                        Object.keys(VISIBILITY).forEach(function(k){
                            VISIBILITY[k].hide.forEach(function(fieldName){
                                var el = rootView.viewRootEl.querySelector('[data-field-def="'+fieldName+'"]');
                                if(el){
                                    el.style.display = "none" ;
                                }
                            }) ;
                        }) ;
                    }else{
                        VISIBILITY[disinf].hide.forEach(function(fieldName){
                            var el = rootView.viewRootEl.querySelector('[data-field-def="'+fieldName+'"]');
                            if(el){
                                el.style.display = "none" ;
                            }
                        }) ;
                        VISIBILITY[disinf].show.forEach(function(fieldName){
                            var el = rootView.viewRootEl.querySelector('[data-field-def="'+fieldName+'"]');
                            if(el){
                                el.style.display = "block" ;
                            }
                        }) ;
                        VISIBILITY[disinf].required.forEach(function(fieldName){
                            var el = rootView.viewRootEl.querySelector('[data-field-def="'+fieldName+'"]');
                            if(el){
                                el.setRequired(true) ;
                            }
                        }) ;
                        if(disinfLongEl){ disinfLongEl.style.display = "block" ; }
                        if(disinfShockEl){ disinfShockEl.style.display = "block" ; }
                        if(disinfSaltEl){ disinfSaltEl.style.display = "none" ; }
                        if (disinf === "SALT") {
                            if(disinfLongEl){ disinfLongEl.style.display = "none" ; }
                            if(disinfSaltEl){ disinfSaltEl.style.display = "block" ; }
                        }
                    }
                }
        
                disinfEl.addEventListener("change", onChange) ;
                view.on("render", onChange) ;
            }
        }) ;
    }) ;
} ;




module.exports = extension ;